import clsx from 'clsx'
import Image from 'next/image'

import { Button, Text } from '@/shared/ui'

import { UnreadDecorations } from './unread-decorations'

import cls from './open-chat-button.module.scss'

type OpenChatButtonIconProps = {
	isOpen: boolean
	open: () => void
}

export const OpenChatButtonIcon = ({ isOpen, open }: OpenChatButtonIconProps) => (
	<Button
		theme="clear"
		className={clsx(cls.iconButton, isOpen && cls['iconButton--hide'])}
		onClick={open}
		id="ai-open-chat"
		aria-label="AI-помощник"
		type="button">
		<Image src="/ai-chat.gif" alt="" width={40} height={40} />
		<Text as="span" className={cls.iconButton__text}>
			AI
		</Text>
		<UnreadDecorations />
	</Button>
)
